<ul class="checkmark-list">
  <li *ngFor="let item of items" class="checkmark-wrapper">
    <app-icon-url
      *ngIf="item.leftIconUrl"
      [icon]="item.leftIconUrl"
      class="left-icon"
    >
    </app-icon-url>
    <app-checkmark *ngIf="!item.leftIconUrl" class="checkmark"> </app-checkmark>

    <ng-container [ngSwitch]="htmlContent">
      <ng-container *ngSwitchCase="true">
        <span [innerHTML]="item.value | safe: 'html'"></span>
      </ng-container>

      <ng-container *ngSwitchDefault>
        {{ item.value }}
      </ng-container>
    </ng-container>

    <app-icon *ngIf="item.rightIcon" class="right-icon" [icon]="item.rightIcon">
    </app-icon>
  </li>
</ul>
